import type { ReactNode } from 'react'
import { forwardRef, useImperativeHandle, useRef } from 'react'

import * as TableOfContents from '@segment/matcha/recipes/TableOfContents'

import { useListContext } from './ListContext'

export interface ListItemProps {
  value: string | number
  href: string
  children: ReactNode
}

const ListItem = forwardRef<HTMLAnchorElement, ListItemProps>(({ value, children, href }, ref) => {
  const elementRef = useRef<HTMLAnchorElement>(null)
  const { active, setActive } = useListContext()
  const isActive = value === active

  useImperativeHandle<HTMLAnchorElement | null, HTMLAnchorElement | null>(ref, () => elementRef.current)

  return (
    <TableOfContents.ListItem
      ref={elementRef}
      active={isActive}
      href={href}
      onClick={(e) => {
        e.preventDefault()
        if (!isActive) {
          setActive?.(value, elementRef)
        }
      }}
    >
      <TableOfContents.LeftContent>
        <TableOfContents.Text variant={isActive ? `buttonLarge` : `formInput`}>{children}</TableOfContents.Text>
      </TableOfContents.LeftContent>
    </TableOfContents.ListItem>
  )
})

export default ListItem
